:host {
  display: block;
}

klevu-typography.caption {
  margin-bottom: var(--klevu-spacing-02);
}
